module.exports = __webpack_public_path__ + "img/icon_route_map_active.a83b1984.svg";